import React from 'react';
import { useEventCallback } from 'rxjs-hooks';
import { debounceTime, filter, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import './SearchInput.scss';
import * as PropTypes from 'prop-types';

export const SearchType = Object.freeze({
    useEnter: Symbol('useEnter'),
    useDebounceOnly: Symbol('useDebounce')
});

export const SearchInput = props => {
    const { searchType } = props;
    const inputProps = _.omit(props, ['onSearch', 'searchType']);

    const [keyPressedCallback] = useEventCallback(event$ =>
        event$.pipe(
            tap(e => e.persist()),
            filter(
                e =>
                    (searchType === SearchType.useEnter && e.which === 13) ||
                    searchType === SearchType.useDebounceOnly
            ),
            debounceTime(500),
            tap(e => props.onSearch(e.target.value)),
            filter(e => e.which === 13),
            tap(e => e.target.blur())
        )
    );

    return (
        <input
            className="search-input"
            onKeyDown={keyPressedCallback}
            {...inputProps}
        />
    );
};

SearchInput.propTypes = {
    onSearch: PropTypes.func,
    searchType: PropTypes.symbol
};

SearchInput.defaultProps = {
    searchType: SearchType.useDebounceOnly,
    onSearch: () => null
};
